import Alert from '@mdi/svg/svg/alert.svg?react';
import Info from '@mdi/svg/svg/information.svg?react';
import { IconWithTooltip } from '@solinkcorp/solink-components';
import { type ScheduledActivityEntity } from 'clients/CallhomeApiTypes';
import React from 'react';
import useLocale from 'src/hooks/useLocale';
import { type UsageQuota } from './useSpotCheckUsage';

interface ActivityFormFooterProps {
  spotCheckUsageStats: UsageQuota | undefined;
  isScheduledAIChat: boolean;
  activity: ScheduledActivityEntity | undefined;
  hasImageCreditsError: boolean;
  leftoverImageCredits?: number;
}

const ActivityFormFooter: React.FC<ActivityFormFooterProps> = ({
  isScheduledAIChat,
  spotCheckUsageStats,
  activity,
  hasImageCreditsError,
  leftoverImageCredits = 0,
}) => {
  const locale = useLocale();

  if (!isScheduledAIChat) {
    return null;
  }

  if (!spotCheckUsageStats && !activity) {
    // we allow editing prompt/answer format for existing activities
    return (
      <IconWithTooltip
        icon={Alert}
        title={locale.scheduledAIChat.usageQuotaApiError}
        fill="var(--color-red)"
      />
    );
  }

  // show zero instead of negative balance
  const creditBalanceToDisplay = Math.max(0, leftoverImageCredits);

  return (
    <div className="spot-check-balance">
      <p>
        {`${locale.scheduledAIChat.spotCheckBalance}: `}
        <span className={hasImageCreditsError ? 'error' : ''}>{creditBalanceToDisplay}</span>
      </p>
      <IconWithTooltip
        icon={Info}
        iconSize={14}
        title={locale.scheduledAIChat.spotCheckBalanceTooltip}
        tooltipContainerClassName="spot-check-balance-tooltip-container"
        className="spot-check-balance-tooltip-button"
      />
    </div>
  );
};

export default ActivityFormFooter;
